/**
 * 任务管理 用车管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item>用车管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="用车人:">
        <el-input
          size="small"
          v-model="formInline.use_name"
          placeholder="输入用车人"
        ></el-input>
      </el-form-item>
      <el-form-item label="车辆编号:">
        <el-input
          size="small"
          v-model="formInline.car_id"
          placeholder="输入车辆编号"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handleAdd()"
          >添加</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      width="100%"
      :data="listData"
      border
      element-loading-text="拼命加载中"
    >
      <el-table-column
        align="center"
        label-aligin="center"
        prop="id"
        fixed
        label="ID"
        width="80"
      ></el-table-column>
      <el-table-column
        align="center"
        label-aligin="center"
        prop="use_name"
        label="用车人"
        width="100"
      ></el-table-column>
      <el-table-column
        align="center"
        label-aligin="center"
        prop="use_tel"
        label="联系方式"
        width="150"
      ></el-table-column>
      <el-table-column
        align="center"
        label-aligin="center"
        prop="car_id"
        label="车辆编号"
        width="200"
      ></el-table-column>
      <el-table-column
        align="center"
        label-aligin="center"
        prop="start_date"
        label="用车时间（开始）"
        width="200"
      ></el-table-column>
      <el-table-column
        align="center"
        label-aligin="center"
        prop="end_date"
        label="用车时间（结束）"
        width="200"
      ></el-table-column>
      <el-table-column
        align="center"
        label-aligin="center"
        prop="car_location"
        label="用车地点"
        width="200"
      ></el-table-column>
      <el-table-column
        align="center"
        label-aligin="center"
        prop="remarks"
        label="备注"
        width="400"
      ></el-table-column>
      <el-table-column
        align="center"
        label-aligin="center"
        label="操作"
        fixed="right"
        width="200"
      >
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>

    <!-- 添加界面 ------------------------------------------------------------------------------>
    <el-dialog
      :title="title"
      :visible.sync="addFormVisible"
      width="30%"
      @click="closeDialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <div style="padding-left:3%,padding-right:10%">
        <el-form
          label-width="120px"
          :model="addForm"
          :rules="rules"
          ref="addForm"
        >
          <el-form-item label="用车人" prop="use_name">
            <el-input
              size="small"
              v-model="addForm.use_name"
              auto-complete="off"
              placeholder="请输入用车人"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="use_tel">
            <el-input
              size="small"
              v-model="addForm.use_tel"
              auto-complete="off"
              placeholder="请输入联系方式"
            ></el-input>
          </el-form-item>
          <el-form-item label="车辆编号" prop="car_id">
            <el-select
              size="small"
              v-model="addForm.car_id"
              clearable
              filterable
              @click="onClick()"
              placeholder="输入车辆编号"
            >
              <el-option
                v-for="item in useCar"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
              <div class="block">
                <el-pagination
                  @size-change="handleSizeChangeCar"
                  @current-change="handleCurrentChangeCar"
                  :current-page.sync="pageAddCar.currentPage"
                  :page-size="pageAddCar.pageSize"
                  layout="prev, pager, next"
                  :pager-count="5"
                  :total="pageAddCar.total"
                >
                </el-pagination>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="用车时间" prop="date">
            <el-date-picker
              size="small"
              v-model="addForm.date"
              type="datetimerange"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['08:00:00', '17:00:00']"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="用车地点" prop="car_location">
            <el-input
              size="small"
              v-model="addForm.car_location"
              auto-complete="off"
              placeholder="请输入用车地点"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input
              size="small"
              type="textarea"
              v-model="addForm.remarks"
              auto-complete="off"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
        <div style="margin-left: 10%">
          <el-button
            size="small"
            type="primary"
            :loading="loading"
            class="title"
            @click="submitAddForm('addForm')"
            >保存</el-button
          >
          <el-button size="small" @click="closeDialog('addForm')"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 编辑界面-------------------------------------------------------------------- -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="30%"
      @click="closeDialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="用车人" prop="use_name">
          <el-input
            size="small"
            v-model="editForm.use_name"
            auto-complete="off"
            placeholder="请输入用车人"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="use_tel">
          <el-input
            size="small"
            v-model="editForm.use_tel"
            auto-complete="off"
            placeholder="请输入联系方式"
          ></el-input>
        </el-form-item>
        <el-form-item label="车辆编号" prop="car_id">
          <el-select
            size="small"
            v-model="editForm.car_id"
            clearable
            filterable
            @click="onClick()"
            placeholder="输入车辆编号"
          >
            <el-option
              v-for="item in use_car"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="pageEditCar.currentPage"
                :page-size="pageEditCar.pageSize"
                :pager-count="5"
                layout="prev, pager, next"
                :total="pageEditCar.total"
              >
              </el-pagination>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="用车时间" prop="date">
          <el-date-picker
            size="small"
            v-model="editForm.date"
            type="datetimerange"
            align="right"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['08:00:00', '17:00:00']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="用车地点" prop="car_location">
          <el-input
            size="small"
            v-model="editForm.car_location"
            auto-complete="off"
            placeholder="请输入用车地点"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input
            type="textarea"
            size="small"
            v-model="editForm.remarks"
            auto-complete="off"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="margin-left: 10%">
        <el-button
          size="mini"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
        <el-button size="mini" @click="closeDialog('editForm')">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  get_task_list,
  get_task_add,
  get_task_edit,
  get_tast_one,
  get_car_id_list,
  get_car_id_list_update,
  get_task_del,
} from "../../api/tast/tast";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      outerline: false,
      outerVisible: false,
      innerVisible: false,
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      addFormVisible: false,
      dialogVisible: false,
      title: "添加",
      addForm: {
        id: "",
        use_name: "",
        use_tel: "",
        car_id: "",
        date: [],
        car_location: "",
        remarks: "",
      },
      editForm: {
        id: "",
        use_name: "",
        use_tel: "",
        car_id: "",
        date: [],
        car_location: "",
        remarks: "",
      },
      useCar: [],
      use_car: [],
      // rules表单验证
      rules: {
        use_name: [
          { required: true, message: "请输入用车人", trigger: "blur" },
          {
            pattern: /^[\u0391-\uFFE5]+$/,
            message: "请用车人姓名，如：李四",
            trigger: "blur",
          },
        ],
        use_tel: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          {
            pattern: /^[1][34578]\d{9}$/,
            message: "请输入正确的联系方式，如：136****6545",
            trigger: "blur",
          },
        ],
        car_id: [
          { required: true, message: "请选择车辆编号", trigger: "change" },
        ],
        date: [
          { required: true, message: "请选择用车时间", trigger: "change" },
        ],
        car_location: [
          { required: true, message: "请输入用车地点", trigger: "blur" },
          {
            pattern: /^[\u0391-\uFFE5]+$/,
            message: "请用车人姓名，如：淄博临淄",
            trigger: "blur",
          },
        ],
      },
      formInline: {
        id: "",
        use_name: "",
        car_id: "",
        page: 1,
        limit: 10,
      },
      carAddInline: {
        page: 1,
        limit: 5,
      },
      carEditInline: {
        car_id: "",
        page: 1,
        limit: 5,
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      pageAddCar: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      pageEditCar: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取列表
    getdata() {
      get_task_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          // this.loading = false;
          this.listData = res.data;
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.limit;
          this.pageparm.total = res["count"];
        } else {
          this.$message.error(res["message"]);
        }
      });
    },
    //获取车辆编号
    getCarAddData() {
      get_car_id_list(this.carAddInline).then((res) => {
        if (res["code"] === 0) {
          this.useCar = res.data;
          this.pageAddCar.currentPage = this.carAddInline.page;
          this.pageAddCar.pageSize = this.carAddInline.limit;
          this.pageAddCar.total = res["count"];
        }
      });
    },
    //修改车辆编号
    getCarEditData() {
      get_car_id_list_update(this.carEditInline).then((res) => {
        if (res["code"] === 0) {
          this.use_car = res.data;
          this.pageEditCar.currentPage = this.carEditInline.page;
          this.pageEditCar.pageSize = this.carEditInline.limit;
          this.pageEditCar.total = res["count"];
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata();
    },
    carAddFather() {
      this.carAddInline.page = this.pageAddCar.currentPage;
      this.carAddInline.limit = this.pageAddCar.pageSize;
      this.getCarAddData();
    },
    carEditFather() {
      this.carEditInline.page = this.pageEditCar.currentPage;
      this.carEditInline.limit = this.pageEditCar.pageSize;
      this.getCarEditData();
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getdata();
    },
    //添加界面
    handleAdd() {
      this.addFormVisible = true;
      this.title = "添加";
      this.getCarAddData();
      this.addForm = {};
    },
    //增加页面保存方法
    submitAddForm(addData) {
      this.$refs[addData].validate((valid) => {
        if (valid) {
          get_task_add(this.addForm).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              this.addFormVisible = false;
              this.getdata();
              this.getCarAddData();
              this.addForm = {};
            } else {
              this.$message.error(res["message"]);
              this.loading = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    //显示编辑界面
    handleEdit(row) {
      this.title = "修改";
      get_tast_one(row.id).then((res) => {
        if (res["code"] === 0) {
          this.editForm = res.data;
          this.carEditInline.page = 1;
          this.carEditInline.car_id = res.data.car_id;
          this.getCarEditData();
          this.$set(this.editForm, "date", [
            res.data.start_date,
            res.data.end_date,
          ]);
          this.editFormVisible = true;
        } else {
          this.$message.error(res["message"]);
        }
      });
    },
    // 编辑页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          get_task_edit(this.editForm).then((res) => {
            this.editFormVisible = false;
            this.loading = false;
            if (res["code"] === 0) {
              this.getdata();
              this.editForm = {};
              this.$message.success(res["message"]);
            } else {
              this.$message.error(res["message"]);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      })
        .then(() => {
          get_task_del(row.id).then((res) => {
            if (res["code"] === 0) {
              if (this.listData.length === 1) {
                if (this.formInline.page === 1) {
                  this.getdata();
                } else {
                  this.formInline.page = this.formInline.page - 1;
                  this.getdata();
                }
              } else {
                this.getdata();
              }
              this.$message.success(res["message"]);
            } else {
              this.$message.error(res["message"]);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChangeCar(val) {
      this.pageAddCar.pageSize = val;
      this.carAddFather();
    },
    handleCurrentChangeCar(val) {
      this.pageAddCar.currentPage = val;
      this.carAddFather();
    },
    handleSizeChange(val) {
      this.pageEditCar.pageSize = val;
      this.carEditFather();
    },
    handleCurrentChange(val) {
      this.pageEditCar.currentPage = val;
      this.carEditFather();
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.addFormVisible = false;
      this.editFormVisible = false;
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 30px;
  width: 100%;
  height: 80px;
}
.userRole {
  width: 100%;
}
.adddefine {
  margin-bottom: 10px;
}

.el-dialog .el-form {
  padding-left: 3%;
  padding-right: 10%;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 350px;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/tast_mn/Usecar_mn.vue